import React, { useState } from "react";
import axios from "axios";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import Visibility from "@material-ui/icons/Visibility";
import { useLocation } from "react-router-dom";
import Headerpage from "src/components/header";
import PasswordStrengthBar from 'react-password-strength-bar'; // Import PasswordStrengthBar
import Footerpage from "src/components/footer";
import { apiUrl } from "src/config/api";
import { decodeEmailQueryParam } from "src/utils/queryParams";
const ResetPassword: React.FC = () => {
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState("");

    const useQuery = () => {
        return new URLSearchParams(useLocation().search);
    };

    const query = useQuery();
    const id = query.get("id");
    const statuss = query.get("status");
    const email = decodeEmailQueryParam(query.get("email"));
    const token = query.get("token");

    // Password validation regex
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;

    const handleResetPassword = async (e: React.FormEvent) => {
        e.preventDefault();
        setError("");
        setSuccess("");
        setLoading(true);

        if (!passwordRegex.test(newPassword)) {
           setError("Password must be at least 8 characters and include uppercase, lowercase, number, and special character.");
        //   alert("Password must be at least 8 characters long and include an uppercase letter, a lowercase letter, a number, and a special character.");
            setLoading(false);
            return;
        }else if (newPassword !== confirmPassword) {
            setError("New password and confirm do not match.")
            // alert("Passwords do not match!")
            setLoading(false);
            return;
        }

        try {
            let response;

            if (statuss === "sidebar") {
                const res = await axios.get(apiUrl("/user"), {
                    withCredentials: true,// include cookies if needed
                    headers: {
                        "Content-Type": "application/json"
                    }
                });
                console.log("ressssssssss", res, success)
                const userid = res?.data?.id;

                if (!userid) {
                    alert("User ID not found!");
                    setLoading(false);
                    return;
                }

                response = await axios.put(apiUrl("/user/changePassword"), {
                    userId: userid,
                    newPassword,
                    confirmPassword,
                }, {
                    headers: { "Content-Type": "application/json" },
                });
            } else{

// STEP 1: First accept invitation (if exists)
if (email && token) {
  try {
    const invitationResponse = await axios.post(
      apiUrl("/accept-invitation"),
      { token, email },
      {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      }
    );

    // Safety check
    if (invitationResponse.status !== 200) {
      alert("Invitation acceptance failed. Please try again.");
      return; // ⛔ STOP further execution
    }

  } catch (err: any) {
    console.error("Error accepting invitation:", err);
    alert(
      err?.response?.data?.message ||
      "Failed to accept invitation. Password not changed."
    );
    return; // ⛔ VERY IMPORTANT: stop password reset
  }
}

// STEP 2: Only after invitation success → reset password
try {
  response = await axios.post(
    apiUrl("/user/resetChangePassword"),
    {
      uniqueId: id,
      newPassword,
      confirmPassword,
    },
    {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    }
  );

  if (response.status === 200) {
    alert(response?.data?.message);
    setNewPassword("");
    setConfirmPassword("");
  }

} catch (err: any) {
  console.error("Password reset error:", err);
  alert(
    err?.response?.data?.message ||
    "Password reset failed. Please try again."
  );
}

               window.location.href = "/";
            }
        } catch (err: any) {
            setError(err.response?.data?.message);
            alert(err.response?.data?.message);
        } finally {
            setLoading(false);
        }
    };

    return (<>
         <Headerpage/>

            <div className="container-inner">
                <div className="content-leader" style={{
                    width: "100%",
                    height: "calc(100vh - 153px)",
                    backgroundImage: `-webkit-gradient(linear, left top, left bottom, from(rgba(62, 124, 177, 0.5)), to(rgba(62, 124, 177, 0.5))),url(${require('src/assets/gritp.jpg')})`
                }}>

                    <div className="change-main-content change-content-main-outer">
                        <h2 style={{ marginBottom: "20px", fontSize: "33px", color: "rgba(0, 0, 94, 1)", textAlign: "center" }}>Create Password</h2>

                        <form onSubmit={handleResetPassword} style={{ display: "flex", flexDirection: "column", gap: "15px" }}>

                            {email && <div style={{
                                position: "relative",
                                display: "flex",
                                alignItems: "center"
                            }}>
                                <input
                                    type="email"
                                    placeholder="Email"
                                    value={email || ""}
                                    disabled={true}
                                    required={true}
                                    style={{
                                        flex: 1,
                                        padding: "12px",
                                        fontSize: "16px",
                                        border: "1px solid #ccc",
                                        borderRadius: "6px",
                                        outline: "none",
                                        backgroundColor: "#f5f5f5",
                                        color: "#666"
                                    }}
                                />
                            </div>}

                            <div style={{
                                position: "relative",
                                display: "flex",
                                alignItems: "center"
                            }}>
                                <input
                                    type={showNewPassword ? "text" : "password"}
                                    placeholder="New Password"
                                    value={newPassword}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setNewPassword(value);
                                        if (!passwordRegex.test(value)) {
                                            setError("Password must be at least 8 characters and include an uppercase letter, lowercase letter, number, and special character.");
                                        } else {
                                            setError(""); // Clear error when validation is fulfilled
                                        }
                                    }}
                                    required={true}
                                    style={{
                                        flex: 1,
                                        padding: "12px",
                                        fontSize: "16px",
                                        border: "1px solid #ccc",
                                        borderRadius: "6px",
                                        outline: "none",
                                        paddingRight: "40px",
                                        maxWidth: "100%",
                                    }}
                                />
                                <span
                                    onClick={() => setShowNewPassword(!showNewPassword)}
                                    style={{
                                        position: "absolute",
                                        right: "10px",
                                        cursor: "pointer"
                                    }}
                                >
                                    {showNewPassword ? <Visibility /> : <VisibilityOff />}
                                </span>
                            </div>
                            {error && <p style={{ color: "red", fontWeight: "bold", marginBottom: "0" , fontSize:"13px"}}>{error}</p>}

                            <div style={{
                                position: "relative",
                                display: "flex",
                               alignItems: "center"
                            }}>
                                <input
                                    type={showConfirmPassword ? "text" : "password"}
                                    placeholder="Confirm Password"
                                    value={confirmPassword}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setConfirmPassword(value);
                                        if (newPassword && newPassword !== value) {
                                            setError("New password and confirm do not match.");
                                        } else {
                                            setError(""); // Clear error when passwords match
                                        }
                                    }}
                                    required={true}
                                    style={{
                                        flex: 1,
                                        padding: "12px",
                                        fontSize: "16px",
                                        border: "1px solid #ccc",
                                        borderRadius: "6px",
                                        outline: "none",
                                        paddingRight: "40px",
                                        maxWidth: "100%",
                                    }}
                                />
                                <span
                                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                    style={{
                                        position: "absolute",
                                        right: "10px",
                                        cursor: "pointer"
                                    }}
                                >
                                    {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                                </span>
                                {/* {error && <p style={{ color: "red", fontWeight: "bold", marginBottom: "0" }}>{error}</p>} */}
                            </div>
                            {newPassword && <PasswordStrengthBar password={newPassword} />} {/* Add Password Strength Bar */}

                            {success && <p style={{ color: "green", fontWeight: "bold" }}>{success}</p>}
                            <button
                                type="submit"
                                disabled={loading}
                                style={{
                                    padding: "12px",
                                    fontSize: "20px",
                                    backgroundColor: loading ? "#ccc" : "rgba(0, 0, 94, 1)",
                                    color: "white",
                                    border: "none",
                                    borderRadius: "6px",
                                    cursor: loading ? "not-allowed" : "pointer",
                                    transition: "background 0.3s",
                                    marginTop: "7px",
                                      // marginBottom: "10px"
                                }}
                            >
                                {loading ? "Changing Password..." : "Confirm Password"}
                            </button>
                        </form>
                    </div>
                </div>
            </div>

         <Footerpage/>

        </> );
};

export default ResetPassword;



// WEBPACK FOOTER //
// ./src/pages/home/signIn-page/changePassword.tsx